
export const UPLOAD_DOCUMENTS_CONSTANTS = {
  UPLOAD_DOCUMENT: "Upload Document",
  UPLOAD_DOCUMENTS: "Upload Document",
  UPLOAD_ADMIN_DOCUMENTS: "Upload Admin Documents",
  CONSTRAIN: "Only PDF or .JPEG files allowed with a maximum limit of 5 MB",
  DOCUMENT_UPLOAD_FIELDS: {
    PHOTOGRAPH_FIELD: {
      title: "Photograph",
      name: "photograph",
      placeholder: "Your recent and clear photograph",
      bold: true,
      takePicture: true
    },
    ID_PROOF_FIELD: {
      title: "Kenyan ID proof",
      name: "idProof",
      bold: true,
      takePicture: true
    },
    KRA_PIN_FIELD: {
      title: "KRA Pin",
      name: "KRAPin",
      bold: true,
      takePicture: true
    },
    APPROVAL_LETTER: {
      title: "Registration document / Approval letter",
      name: "registration_document",
      bold: false,
      takePicture: true
    },
    RE_UPLOAD_APPROVAL_LETTER: {
      title: "Registration document / Approval letter",
      name: "registrationDocument",
      bold: false,
      takePicture: true
    }
  },
  NEXT: "Next",
  RESUBMIT: "Re-submit",
  START_INVESTING: "Start Investing Today!",
  GROUP_DETAILS: "Group Details",
  PROCEED: "Proceed",
  ADMIN_DETAILS: "Admin Details",
  ADD_MEMBER_DETAILS: "Add Member Detail (Optional)",
  TELL_US_ABOUT_YOURSELF: "Tell Us More About Yourself",
  SKIP: "Skip",

};
